function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { any, bool, oneOf } from 'prop-types';
import classNames from 'classnames';
import styles from './ButtonLayout.scss';

var ButtonLayout = function ButtonLayout(props) {
  var _classNames;

  var theme = props.theme,
      hover = props.hover,
      active = props.active,
      disabled = props.disabled,
      height = props.height,
      children = props.children;


  var className = classNames((_classNames = {}, _defineProperty(_classNames, styles.button, true), _defineProperty(_classNames, styles[theme], true), _defineProperty(_classNames, styles.hover, hover), _defineProperty(_classNames, styles.active, active), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles['height' + height], height !== 'medium'), _classNames), children.props.className);

  var _style = Object.assign({}, children.props.style, {
    height: height,
    display: 'inline-block'
  });

  if (React.Children.count(children) === 1) {
    return React.cloneElement(children, { className: className, style: _style }, React.createElement(
      'div',
      { className: styles.inner },
      children.props.children
    ));
  }
};

ButtonLayout.defaultProps = {
  height: 'medium',
  theme: 'fullblue'
};

ButtonLayout.propTypes = {
  active: bool,
  children: any,
  disabled: bool,
  height: oneOf(['small', 'medium', 'large', 'x-large']),
  hover: bool,
  theme: oneOf(['transparent', 'fullred', 'fullgreen', 'fullpurple', 'emptyred', 'emptygreen', 'emptybluesecondary', 'emptyblue', 'emptypurple', 'fullblue', 'login', 'emptylogin', 'transparentblue', 'whiteblue', 'whiteblueprimary', 'whitebluesecondary', 'close-standard', 'close-dark', 'close-transparent', 'icon-greybackground', 'icon-standard', 'icon-standardsecondary', 'icon-white', 'icon-whitesecondary'])
};

ButtonLayout.displayName = 'ButtonLayout';

export default ButtonLayout;
//# sourceMappingURL=ButtonLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ButtonLayout/ButtonLayout.js